/** Consultancy-tier Standard EA for mining. Enquiry-first. Not a DIY PDF. */

export const STANDARD_EA_MINING_SLUG = "standard-ea-mining";
export const STANDARD_EA_MINING_SERVICE_ID = "standard-ea-mining";

/** Fee portion A$7,500. Display as + GST, not ex GST. */
export const STANDARD_EA_MINING_FEE_CENTS = 750_000;

const GST_RATE = 0.1;

function aud(cents: number): string {
  return new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(cents / 100);
}

export const STANDARD_EA_MINING = {
  slug: STANDARD_EA_MINING_SLUG,
  id: STANDARD_EA_MINING_SERVICE_ID,
  name: "Standard Environmental Authority applications for mining",
  short: "Standard EA mining",
  summary:
    "Scoped consultancy to prepare and lodge a Standard Environmental Authority application for a mining project in Australia.",
  description:
    "Queensland-style Standard EA is the usual frame. We prepare and lodge the application from your site facts and the standard conditions that apply. Eligibility and agency requirements decide the pathway. This is consultancy, not a DIY PDF and not a 48-hour guided pack.",
  priceLine: "A$7,500.00 + GST",
  difyService: "AU · Standard Environmental Authority applications for mining",
} as const;

export function isStandardEaMiningId(id: string | null | undefined): boolean {
  return id === STANDARD_EA_MINING_SERVICE_ID;
}

export function isStandardEaMiningServiceParam(value: string | null | undefined): boolean {
  if (!value) return false;
  const v = value.toLowerCase();
  return (
    v.includes("standard environmental authority") ||
    v === STANDARD_EA_MINING.difyService.toLowerCase()
  );
}

export function standardEaMiningMoney(feeCents = STANDARD_EA_MINING_FEE_CENTS) {
  const gstCents = Math.round(feeCents * GST_RATE);
  return {
    feeCents,
    gstCents,
    inclCents: feeCents + gstCents,
    fee: aud(feeCents),
    gst: aud(gstCents),
    incl: aud(feeCents + gstCents),
    plusGstLine: `${aud(feeCents)} + GST`,
  };
}

export function standardEaMiningEnquiryPath(): string {
  return `/contact?service=${encodeURIComponent(STANDARD_EA_MINING.difyService)}`;
}
